require('./receiptsTableRow.scss');
import PropTypes from 'prop-types';
// @ vendor
import React from 'react';
import { connect } from 'react-redux';
// @ commons
import ActionsTableCell from 'components/commons/actionsTableCell/actionsTableCell';
import CategoryTableCell from 'components/commons/categoryTableCell/categoryTableCell';
import OKTag from 'components/commons/OKTag/OKTag';
import { OKTableRow } from 'commonsComponents/OKTableRow';
import { OKTableCell } from 'commonsComponents/OKTableCell';
// @ components
import { OneLineSymbolAmount } from 'commonsComponents/oneLineSymbolAmount';
import { LabelDate } from 'commonsComponents/labelDate';
// @ actions
import { requestAccountDebitsPdf } from 'actions/accountDebits';
// @ core
import { i18n } from 'core/i18n';
const { formatText, getLanguage } = i18n;
// @ helpers
import { formatAmountObject, getPlainAmountObject } from 'utilities/currencyHelper';
import {
    AUTHORIZATION_ACTIVE,
    AUTHORIZATION_CANCELED,
    RECEIPT_STATUS_TERM_CANCELED,
    RECEIPT_STATUS_TERM_PAID,
    RECEIPT_STATUS_TERM_REJECTED,
    RECEIPT_STATUS_TERM_RETURNED,
    RECEIPT_STATUS_TERM_PENDING,
    RECEIPT_STATUS_CODES_PENDING

} from 'constants/index';
import { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } from 'constants/commonsComponents';
import { OKCollapsingToggler } from 'commonsComponents/OKCollapsingToggler';
import { getNumOfDaysBetweenDates } from 'utilities/dateHelper';
// @ Constants
import { ACCOUNT_DEBITS_RECEIPT_DAY_TO_ALLOW_RETURN } from 'constants/index';
const RECEIPT_STATUS = {
    ANU: RECEIPT_STATUS_TERM_CANCELED,
    APL: RECEIPT_STATUS_TERM_PAID,
    APR: RECEIPT_STATUS_TERM_REJECTED,
    DEV: RECEIPT_STATUS_TERM_RETURNED,
    PAB: RECEIPT_STATUS_TERM_RETURNED,
    PAN: RECEIPT_STATUS_TERM_PENDING,
    PAP: RECEIPT_STATUS_TERM_PENDING,
    PTD: RECEIPT_STATUS_TERM_REJECTED,
    PTF: RECEIPT_STATUS_TERM_PENDING,
    PTR: RECEIPT_STATUS_TERM_PENDING
};

class ReceiptsTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.renderOptions = this.renderOptions.bind(this)
    };

    onRowClick = () => {
        const { id, onRowClick } = this.props;
        onRowClick(id);
    }

    handleGetPdf = (immTransaction) => {
        const { requestAccountDebitsPdf } = this.props;
        requestAccountDebitsPdf(immTransaction)
    }

    renderOptions = (accountId, immTransaction) => {
        const { immAccounts, immAuthorization } = this.props;
        const receiptNumber = immTransaction.get('receiptNumber');
        const date = immTransaction.get('fecvenci');
        const authorizationId = immTransaction.get('authorizationId');
        const statusKey = RECEIPT_STATUS[immTransaction.get('cestado')];
        const immAccount = immAccounts.get('byId').get(accountId);
        const isInactiveAccount = immAccount.get('isInactiveAccount');
        const transactionAccountId = immTransaction.get('accountId');
        const status = immAuthorization.getIn([transactionAccountId, 'byId', authorizationId, 'status']) || '';

        return [
            ...(!__CONTACT_CENTER__ && !RECEIPT_STATUS_CODES_PENDING.includes(immTransaction.get('cestado')) ? [{
                handleClick: () => this.handleGetPdf(immTransaction),
                text: formatText('accountDebitDetail-toolTipViewReceipt')
            }] : []),
            ...((statusKey === RECEIPT_STATUS_TERM_PAID || statusKey === RECEIPT_STATUS_TERM_CANCELED) && getNumOfDaysBetweenDates(date) < ACCOUNT_DEBITS_RECEIPT_DAY_TO_ALLOW_RETURN ? [{
                link: `/myprofile/accounts/${accountId}/debits/returns/${receiptNumber}`,
                text: formatText('accountDebitReturn-return'),
                disabled: isInactiveAccount,
                icon: isInactiveAccount && 'icon-candado'
            }] : []),
            {
                link: `/myprofile/accounts/${accountId}/debits/authorizationModifyAccount/${authorizationId}`,
                text: formatText('accountDebits-authorizationModifyAccount')
            },
            ...(status === AUTHORIZATION_ACTIVE ? [{
                link: `/myprofile/accounts/${accountId}/debits/annulationPayments/${receiptNumber}`,
                text: formatText('authorizations-cancelAuthorization')
            }] : []),
            ...(status === AUTHORIZATION_CANCELED ? [{
                link: `/myprofile/accounts/${accountId}/debits/activationPayments/${authorizationId}`,
                text: formatText('authorizations-activateAuthorization')
            }] : [])
        ]
    }

    render() {
        const {
            immTransaction,
            id,
            isExpanded
        } = this.props;
        const accountId = immTransaction.get('accountId');
        const category = immTransaction.getIn(['category', 'category']);
        const subcategory = immTransaction.getIn(['category', 'subcategory']);
        const statusKey = RECEIPT_STATUS[immTransaction.get('cestado')];
        const renderOptions = this.renderOptions(accountId, immTransaction);
        let tagType;
        let optionsDropdown;

        if([RECEIPT_STATUS_TERM_RETURNED, RECEIPT_STATUS_TERM_REJECTED].includes(statusKey)){
            tagType = 'warning';
        }else if(statusKey === RECEIPT_STATUS_TERM_PAID){
            tagType = 'success';
        }

        if (renderOptions.length > 0){
            optionsDropdown = (
                <OKTableCell className="receipts-table-row__actions">
                    <ActionsTableCell
                        options={renderOptions}
                        translationKey={'manageDevices-options'}
                    />
                </OKTableCell>
            );
        }

        const plainAmountObject = getPlainAmountObject(immTransaction.get('amount'));
        const language = getLanguage();
        const tagContent = `receipts-${statusKey}`;
        return (
            <OKTableRow id={id} isExpanded={isExpanded} >
                <OKTableCell className="receipts-table-row__expand-button">
                    <OKCollapsingToggler handlerToggle={this.onRowClick} isExpanded={isExpanded} isIconSecondary={true} />
                </OKTableCell>
                <OKTableCell>
                    <LabelDate
                        date={immTransaction.get('fecvenci')}
                        language={language}
                        today={LABEL_DATE_TODAY}
                        yesterday={LABEL_DATE_YESTERDAY}
                    />
                </OKTableCell>
                <OKTableCell>
                    <CategoryTableCell
                        category={category}
                        customClassName={''}
                        highlighted={isExpanded}
                        subcategory={subcategory}
                    />
                </OKTableCell>
                <OKTableCell className={`receipts-table-row__name${isExpanded ? '--highlighted' : ''}`}>
                    {immTransaction.get('nombre')}
                </OKTableCell>
                <OKTableCell className="receipts-table-row__status">
                    <OKTag
                        content={tagContent}
                        context="arrow"
                        type={tagType}
                        emphasis={true}
                    />
                </OKTableCell>
                <OKTableCell className="receipts-table-row__amount">
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                </OKTableCell>
                {optionsDropdown}
            </OKTableRow>
        );
    }
}

ReceiptsTableRow.propTypes = {
    id: PropTypes.string.isRequired,
    immAccounts: PropTypes.object,
    immAuthorization: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object,
    immTransaction: PropTypes.object.isRequired,
    isExpandable: PropTypes.bool,
    isExpanded: PropTypes.bool,
    onRowClick: PropTypes.func,
    requestAccountDebitsPdf: PropTypes.func.isRequired
};

ReceiptsTableRow.defaultProps = {
    onRowClick: () => { }
};

module.exports.constructor = ReceiptsTableRow;

export default connect(
    (state) => {
        return {
            immAuthorization: state.authorizations,
            immAccounts: state.accounts
        }
    },
   {
        requestAccountDebitsPdf
   }
)(ReceiptsTableRow);
